import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <div className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-black text-background-200 select-none pointer-events-none z-0">
        404
      </div>
      <div className="relative z-10">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm text-foreground-500">该页面不存在或已被移除</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-left-line"></i> 返回首页
        </Link>
      </div>
    </div>
  );
}